import React from 'react';
import Layout from '../components/Layout';
import AdminTaskMonitor from '../components/AdminTaskMonitor';
import { Heading } from '../components/ui/heading';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';

const AdminTaskMonitorPage: React.FC = () => {
  const { user } = useAuth();
  
  // Check if user is admin
  const isAdmin = user?.role?.toLowerCase?.() === 'admin';

  // Redirect non-admin users
  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <Layout>
      <div className="container mx-auto px-4 py-8">
        <Heading level={1} weight="bold" className="mb-8">Task Monitoring</Heading>
        <AdminTaskMonitor />
      </div>
    </Layout>
  );
};

export default AdminTaskMonitorPage;